import React,{Component } from 'react';
import {Link} from 'react-router';
import WebHeaderInner from './../Common/WebHeaderInner.js';
import WebFooter from './../Common/WebFooter.js';

// const baseUrl='https://aquadeals.in/admin/web3/user/';
// const baseAssets='https://aquadeals.in/admin/assets/';

export default class Order_aborted extends Component{
	constructor(props){
		super(props);
		this.state={
			status_title: 'Transaction Aborted',
		};
	}
	componentDidMount()
	{
		window.scrollTo(0, 0);
		if(screen.width < 800)
		{
		    window.location.href="/status/"+this.props.params.Type;
		}
	}
	render(){
		var status_title = '';
		if(this.props.params.Type === 'aborted')
		{
			status_title='Transaction Aborted';
		}
		else if(this.props.params.Type ==='failure')
		{
			status_title='Transaction Failed';
		}
		else if(this.props.params.Type ==='invalid')
		{
			status_title= 'Invalid Transaction';
		}
		else if(this.props.params.Type === 'serverDown')
		{
			status_title='Server Down';
		}
		else
		{
			status_title = 'Something went wrong!';
		}
		return(
			<div className="web_deals web_order_aborted_page">
			    <WebHeaderInner />
					<div className="clr">&nbsp;</div>
			        <div className="clr">&nbsp;</div>
			        <section className="container">
				 		<div className="row">
				 			<div className="col-md-6 col-md-offset-3 web_dels_cntnt">
				    			<div className="web_abort_content">
					    			<h4>{status_title}</h4>
					    			<a href={'/web/mycart'} className="web_try_again_btn">Try again</a>
					    		</div>
					    	</div>
						</div>		
					</section>
				<WebFooter />
			</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Cart/Web_Order_aborted.js
 **/